import React from "react";
import "./OpticMotorControl.css";
import ImagingArmSpeedSlider from "../../../Imager/ImagingArmSpeedSlider";
import MtiButton from "../../../Buttons/MtiButton";

type Props = {
  position: number;
  onMoveLeft: () => void;
  onMoveRight: () => void;
  onMoveMin: () => void;
  onMoveMax: () => void;
  onMouseUp: () => void;
  onInputPosition: () => void;
  speed: number;
  onSpeedChanged: (speed: number) => void;
  style?: React.CSSProperties;
};

export default function OpticMotorControl({
  position,
  onMoveLeft,
  onMoveRight,
  onMoveMin,
  onMoveMax,
  onMouseUp,
  onInputPosition,
  speed,
  onSpeedChanged,
  style = {},
}: Props) {
  return (
    <div
      className="optic-motor-control-container"
      style={{
        ...style,
      }}
    >
      <span>Position</span>
      <div className="optic-motor-control-position">{position.toFixed(2)}</div>
      <span
        style={{
          margin: "0px 20px 0px 10px",
        }}
      >
        U
      </span>
      <div className="optic-motor-control-movement">
        <button
          onMouseDown={onMoveLeft}
          onMouseUp={onMouseUp}
          className="optic-motor-control-movement-button"
          style={{
            gridArea: "left",
          }}
        >
          <svg width="10" height="16" viewBox="0 0 10 16" fill="none">
            <path d="M10 0L0 8L10 16V11V10V6V5L10 0Z" fill="white" />
          </svg>
        </button>
        <button
          onMouseDown={onMoveRight}
          onMouseUp={onMouseUp}
          className="optic-motor-control-movement-button"
          style={{
            gridArea: "right",
          }}
        >
          <svg width="10" height="16" viewBox="0 0 10 16" fill="none">
            <path d="M0 0L10 8L0 16V11V10V6V5L0 0Z" fill="white" />
          </svg>
        </button>
        <button
          onClick={onMoveMin}
          className="optic-motor-control-movement-button"
          style={{
            gridArea: "min",
          }}
        >
          <svg width="12" height="17" viewBox="0 0 12 17" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2 0.606827H0V16.6068H2V8.60683L12 16.6068V11.6068V10.6068V6.60683V5.60683V0.606827L2 8.60683V0.606827Z"
              fill="white"
            />
          </svg>
        </button>
        <button
          onClick={onMoveMax}
          className="optic-motor-control-movement-button"
          style={{
            gridArea: "max",
          }}
        >
          <svg width="12" height="18" viewBox="0 0 12 18" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 17.2092H12V0.140949H10V8.67507L0 0.140949V5.47478V6.54154V10.8086V11.8754V17.2092L10 8.67507V17.2092Z"
              fill="white"
            />
          </svg>
        </button>

        <ImagingArmSpeedSlider
          value={speed}
          onValueChanged={onSpeedChanged}
          style={{
            gridArea: "slider",
          }}
        />
      </div>
      <MtiButton className="optic-motor-control-input-button" onClick={onInputPosition}>
        INPUT POSITION
      </MtiButton>
    </div>
  );
}
